// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Ynbk","footer":"Form_footer__2DrEk"};